import { FormGroup } from '@angular/forms';

export interface AuthPageProvider {
  getForm: () => FormGroup;
  onSuccess: (response: any) => void;
  onFail: (error: any) => void;
}
